var render = function () {
  var _vm$currentRound, _vm$currentRound3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'face-flip',
      "customContentContainerStyles": {
        height: 'calc(100% - 61px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _vm.currentRound.steps ? _c('article', {
    staticClass: "face-flip-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    ref: "faceCards",
    staticClass: "top"
  }, _vm._l((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.steps, function (step, index) {
    var _step$answerImage, _step$answerImage$ima, _vm$currentRound$card, _vm$currentRound2, _vm$currentRound2$car, _step$answerImage2, _step$answerImage2$im, _step$answerImage3, _step$answerImage3$im;
    return _c('li', {
      key: (_step$answerImage = step.answerImage) === null || _step$answerImage === void 0 ? void 0 : (_step$answerImage$ima = _step$answerImage.image) === null || _step$answerImage$ima === void 0 ? void 0 : _step$answerImage$ima.src,
      staticClass: "card-item",
      attrs: {
        "transition": "kwtStagger"
      }
    }, [_c('flippable-card', {
      attrs: {
        "is-flipped": index === _vm.progress.stepIndex || _vm.showAllCards
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back"
      },
      slot: "card-back"
    }, [_c('img', {
      staticStyle: {
        "max-width": "264px",
        "max-height": "304px"
      },
      attrs: {
        "alt": "Back of card image",
        "src": (_vm$currentRound$card = (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$car = _vm$currentRound2.cardBack) === null || _vm$currentRound2$car === void 0 ? void 0 : _vm$currentRound2$car.src) !== null && _vm$currentRound$card !== void 0 ? _vm$currentRound$card : _vm.backOfCardPath
      }
    })]), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front"
      },
      slot: "card-front"
    }, [_c('img', {
      staticStyle: {
        "max-width": "264px",
        "max-height": "304px"
      },
      attrs: {
        "alt": (_step$answerImage2 = step.answerImage) === null || _step$answerImage2 === void 0 ? void 0 : (_step$answerImage2$im = _step$answerImage2.image) === null || _step$answerImage2$im === void 0 ? void 0 : _step$answerImage2$im.description,
        "src": (_step$answerImage3 = step.answerImage) === null || _step$answerImage3 === void 0 ? void 0 : (_step$answerImage3$im = _step$answerImage3.image) === null || _step$answerImage3$im === void 0 ? void 0 : _step$answerImage3$im.src
      }
    })])])], 1);
  }), 0), _c('div', {
    staticClass: "bottom"
  }, [_vm._l((_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : _vm$currentRound3.steps, function (step, index) {
    return _c('div', {
      key: ("text_" + index),
      staticClass: "td-container"
    }, [index === _vm.progress.stepIndex ? _c('blinking-cursor-text', {
      attrs: {
        "transition": "slide-in",
        "text": step.answer,
        "text-step": index
      }
    }) : _vm._e()], 1);
  }), _c('div', {
    attrs: {
      "aria-live": "assertive",
      "role": "region"
    }
  }, [_vm.showAllCards ? _c('success-check-solid-icon', {
    attrs: {
      "height": "26",
      "width": "37"
    }
  }) : _vm._e()], 1)], 2)]) : _vm._e()], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }